<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input class="filter-item" v-model="listQuery.querymodel.keyword" placeholder="姓名/账号/手机号" style="width: 200px"
        @keyup.enter.native="getList()" />
      <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    </div>
    <el-table class="app-table" :data="list" border fit highlight-current-row stripe style="width: 100%"
      :height="getViewHeight()" :header-cell-style="{ background: '#F3F4F7', color: '#555' }"
      :row-style="{ height: '10px' }" :cell-style="{ padding: '7px 0' }">
      <el-table-column :key="i" v-for="(col, i) in columns" :label="col.label" :align="col.align" :prop="col.value"
        :type="col.type" :width="col.width">
      </el-table-column>
      <el-table-column :min-width="200" label="操作" align="center">
        <template slot-scope="{ row }">
          <el-button type="primary" size="mini" icon="el-icon-edit" v-if="authedit" @click="edit(row)">
            编辑
          </el-button>
          <el-button v-if="authdelete && !row.SystemMark" icon="el-icon-delete" size="mini" type="danger"
            @click="deleted(row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageIndex" :limit.sync="listQuery.pageSize"
      @pagination="getList" />
    <addemp v-if="dialogshow" :dialogshow="dialogshow" :isedit="isedit" :editform="editform"
      @savecomplete="savecomplete" @cancelcomplete="cancelcomplete"></addemp>
  </div>
</template>
<script>
import { employeeroletree } from "@/api/role";
import {
  getempbyid,
  queryemp,
  deleteemp,
} from "@/api/employee";
import waves from "@/directive/waves"; // waves directive
import { getButtonList } from "../../promissionRouter";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import Toolbar from "../../components/Toolbar";
import Addemp from "./components/addemp.vue";
export default {
  components: { Pagination, Toolbar, Addemp },
  directives: { waves },
  data() {
    return {
      buttonList: [],
      list: null,
      pageIndex: 1,
      total: 0,
      isedit: false,
      authedit: false,
      authdelete: false,
      editform: {},
      createform: {},
      columns: [
        { label: "序号", value: "index", align: "center", type: "index", width: 100 },
        { label: "账号", value: "EmpCode", align: "center", type: "" },
        { label: "姓名", value: "EmpName", align: "center", type: "" },
        { label: "手机号", value: "MobilePhone", align: "center", type: "" },
        { label: "创建时间", value: "CreateTime", align: "center" },
      ],
      listQuery: {
        pageIndex: 1,
        pageSize: 15,
        orderColumn: "",
        orderbyasc: false,
        querymodel: {
          EnableMark: -1,
          ShopMark: -1,
          keyword: "",
        },
      },
      dialogshow: false,
      rules: {
        RoleName: [
          { required: true, message: "角色名称不能为空", trigger: "change" },
        ],
      },
      saleauthlist: [],
      webauthlist: [],
    };
  },
  created() {
    employeeroletree().then((res) => {
      this.createform = {
        Id: 0,
        EmpCode: "",
        EmpName: "",
        EnableMark: true,
        Password: "",
        MobilePhone: "",
        EmpRoleId: "",
        Gender: "",
        CollertorMark: true,
        BindSectionMark: true,
        SectionIds: "",
        ManageMark: false,
        SaleAuths: "",
        AllOutMark: false,
        editamountmark: false,
        editendtimemark: false,
        FreeQrcodeMark: false,
        BarrierGateCmdMark: false,
        authdetails: {
          webauthlist: res.webauthlist,
          saleauthlist: res.saleauthlist,
        },
      };
    });
    this.getList();
  },
  methods: {
    callFunction(item) {
      this[item.BtnCode].apply(this, item);
    },
    savecomplete(item) {
      this.dialogshow = false;
      this.getList();
    },
    cancelcomplete() {
      this.dialogshow = false;
    },
    create() {
      this.editform = JSON.parse(JSON.stringify(this.createform));
      this.dialogshow = true;
      this.isedit = false;
    },
    edit(row) {
      this.isedit = true;
      this.editform = row;
      getempbyid({ id: row.Id }).then((res) => {
        this.dialogshow = true;
        this.editform.authdetails = {};
        this.editform.authdetails.webauthlist = res.webauthlist;
        this.editform.authdetails.saleauthlist = res.saleauthlist;
      });
    },
    deleted(row) {
      this.$confirm("确定删除该角色吗?", "提示", {
        type: "warning",
      }).then(() => {
        deleteemp({ id: row.Id }).then((res) => {
          this.$message({
            message: "删除成功！",
            type: "success",
          });
          this.getList();
        });
      });
    },
    getList(item) {
      if (item != null && item != undefined) {
        this.listQuery.pageIndex = item.page;
        this.listQuery.pageSize = item.limit;
      } else {
        this.listQuery.pageIndex = 1;
      }
      queryemp(this.listQuery).then((res) => {
        this.list = res.data;
        this.total = res.dataCount;
      });
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.buttonList.forEach((item) => {
      if (item.BtnCode === "delete") {
        this.authdelete = true;
      }
      if (item.BtnCode === "edit") {
        this.authedit = true;
      }
    });
  },
};
</script>
